/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu June 15 2021 14:30:00 PM
 *
 *******************************************************/
//flow
import _ from 'lodash';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Banner, TextStyle } from '@shopify/polaris';
import { getThemes } from 'actions/theme-setup-actions';

type Props = {
  tenantApp: Object,
  emailSupport: string,
  existedThemeLibV2: boolean,
  themesLoading: boolean,
  getThemes: () => void
};

type ComposedProps = Props & WithI18nProps;

const ThemeUpgradeFlow2Notification: React.FC<ComposedProps> = ({
  tenantApp,
  emailSupport,
  existedThemeLibV2,
  themesLoading,
  i18n,
  getThemes
}) => {
  const { liveThemeV2 = false, liveThemeV3 = false, adminAppFeatures = {} } = tenantApp;
  const { themeSetupV2 = false } = adminAppFeatures;
  const enableBanner =
    !liveThemeV2 && themeSetupV2 && !liveThemeV3 && !themesLoading && !existedThemeLibV2;

  useEffect(() => {
    getThemes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!enableBanner) return null;

  return (
    <Banner
      status="warning"
      title={i18n.translate('AdminHTML.ThemeSetup.ThemeUpgradeFlow2Notification.title')}>
      <p>
        {i18n.translate('AdminHTML.ThemeSetup.ThemeUpgradeFlow2Notification.content1', {
          t: (
            <TextStyle variation="strong">
              {i18n.translate('AdminHTML.ThemeSetup.ThemeUpgradeFlow2Notification.content1_t')}
            </TextStyle>
          )
        })}
      </p>
      <br />
      <p>
        {i18n.translate('AdminHTML.ThemeSetup.ThemeUpgradeFlow2Notification.content2', {
          nt_email: <TextStyle variation="strong">{emailSupport}</TextStyle>
        })}
      </p>
    </Banner>
  );
};

const mapStateToProps = state => ({
  tenantApp: _.get(state.oauth, 'tenantApp', {}),
  existedThemeLibV2: _.get(state.themeSetup, 'existedThemeLibV2', false),
  themesLoading: _.get(state.themeSetup, 'getThemesLoading', false),
  emailSupport: _.get(state.oauth, 'emailSupport')
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getThemes: () => dispatch(getThemes(ownProps.i18n, true))
});

export default withI18n()(
  connect(mapStateToProps, mapDispatchToProps)(ThemeUpgradeFlow2Notification)
);
